// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const GenerateTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.generateTitle"
        description="Generate title."
        defaultMessage="Generate WebAR Lens URL"
    />
);
GenerateTitle.displayName = "GenerateTitle";

export const GenerateBody = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.generateBody"
        description="Generate body."
        defaultMessage="Generate a URL and make your Lens publicly accessible on the web. By doing so, you consent to its public availability. Please make sure to test your Lenses as not every feature is supported on the web."
    />
);
GenerateBody.displayName = "GenerateBody";

export const GenerateCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.generateCTA"
        description="Generate ct a."
        defaultMessage="Generate WebAR Lens URL"
    />
);
GenerateCTA.displayName = "GenerateCTA";

export const UpdateToDraftTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToDraftTitle"
        description="Update to draft title."
        defaultMessage="Disable WebAR URL"
    />
);
UpdateToDraftTitle.displayName = "UpdateToDraftTitle";

export const UpdateToDraftBody = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToDraftBody"
        description="Update to draft body."
        defaultMessage="Removes your selected Lens from being publicly available at the generated URL. You can re-enable it anytime."
    />
);
UpdateToDraftBody.displayName = "UpdateToDraftBody";

export const UpdateToDraftCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToDraftCTA"
        description="Update to draft ct a."
        defaultMessage="Disable WebAR URL"
    />
);
UpdateToDraftCTA.displayName = "UpdateToDraftCTA";

export const UpdateToPublishedTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToPublishedTitle"
        description="Update to published title."
        defaultMessage="Re-enable URL"
    />
);
UpdateToPublishedTitle.displayName = "UpdateToPublishedTitle";

export const UpdateToPublishedBody = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToPublishedBody"
        description="Update to published body."
        defaultMessage="Re-enabling the URL makes your Lens publicly accessible at the generated URL."
    />
);
UpdateToPublishedBody.displayName = "UpdateToPublishedBody";

export const UpdateToPublishedCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.updateToPublishedCTA"
        description="Update to published ct a."
        defaultMessage="Re-enable URL"
    />
);
UpdateToPublishedCTA.displayName = "UpdateToPublishedCTA";

export const DeleteTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.deleteTitle"
        description="Delete title."
        defaultMessage="Delete WebAR Lens URL"
    />
);
DeleteTitle.displayName = "DeleteTitle";

export const GenerateHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.generateHeader"
        description="Generate header."
        defaultMessage="Generate"
    />
);
GenerateHeader.displayName = "GenerateHeader";

export const DeleteHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.deleteHeader"
        description="Delete header."
        defaultMessage="Delete"
    />
);
DeleteHeader.displayName = "DeleteHeader";

export const DeleteBody = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.deleteBody"
        description="Delete body."
        defaultMessage="Deleting the WebAR URL removes public access to your Lens and destroys the generated URL. Use this option if you want to permanently disable public access to your Lens or if you would like to generate a completely new URL"
    />
);
DeleteBody.displayName = "DeleteBody";

export const DeleteCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.deleteCTA"
        description="Delete ct a."
        defaultMessage="Delete WebAR Lens URL"
    />
);
DeleteCTA.displayName = "DeleteCTA";

export const HostedLensEmptyTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensEmptyTitle"
        description="Hosted lens empty title."
        defaultMessage="Launch Your Lens on the Web!"
    />
);
HostedLensEmptyTitle.displayName = "HostedLensEmptyTitle";

export const HostedLensBody = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensBody"
        description="Hosted lens body."
        defaultMessage="Turn any Lens into its own WebAR experience with a unique URL, hosted by Snap for free!"
    />
);
HostedLensBody.displayName = "HostedLensBody";

export const HostedLensDisclaimer = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensDisclaimer"
        description="Hosted lens disclaimer."
        defaultMessage="By generating a Hosted WebAR Lens, you consent to the Lens' public availability. Please make sure to test your Lenses as not every feature is supported on the web."
    />
);
HostedLensDisclaimer.displayName = "HostedLensDisclaimer";

export const HostedLensCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensCTA"
        description="Hosted lens ct a."
        defaultMessage="Click the button below to generate your unique URL and make your Lens publicly accessible on the web.."
    />
);
HostedLensCTA.displayName = "HostedLensCTA";

export const HostedLensDetailsHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensDetailsHeader"
        description="Hosted lens details header."
        defaultMessage="Hosted WebAR Lens Details"
    />
);
HostedLensDetailsHeader.displayName = "HostedLensDetailsHeader";

export const DeleteHostedLensURL = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.deleteHostedLensURL"
        description="Delete hosted lens ur l."
        defaultMessage="Delete WebAR Lens URL"
    />
);
DeleteHostedLensURL.displayName = "DeleteHostedLensURL";

export const HostedLensOffline = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensOffline"
        description="Hosted lens offline."
        defaultMessage="Set your Lens visibility to Hidden or Public to enable the WebAR Lens URL."
    />
);
HostedLensOffline.displayName = "HostedLensOffline";

export const HostedLensNotAvailable = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensNotAvailable"
        description="Hosted lens not available."
        defaultMessage="Your Lens needs approval to be eligible for a WebAR Lens URL."
    />
);
HostedLensNotAvailable.displayName = "HostedLensNotAvailable";

export const HostedLensTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensTitle"
        description="Hosted lens title."
        defaultMessage="Hosted WebAR Lenses"
    />
);
HostedLensTitle.displayName = "HostedLensTitle";

export const SectionLensURLLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionLensURLLabel"
        description="Section lens url label."
        defaultMessage="WebAR Lens URL"
    />
);
SectionLensURLLabel.displayName = "SectionLensURLLabel";

export const SectionLensURLTooltipContent = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionLensURLTooltipContent"
        description="Section lens url tooltip content."
        defaultMessage="A uniquely generated URL for a selected Lens. This URL can be shared and accessed by anyone, allowing the public to view your Lens from any browser."
    />
);
SectionLensURLTooltipContent.displayName = "SectionLensURLTooltipContent";

export const SectionLensStatusLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionLensStatusLabel"
        description="Section lens status label."
        defaultMessage="WebAR Lens Status"
    />
);
SectionLensStatusLabel.displayName = "SectionLensStatusLabel";

export const SectionStatusTooltipContent = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionStatusTooltipContent"
        description="Section status tooltip content."
        defaultMessage="Determines visibility of your WebAR Lens URL"
    />
);
SectionStatusTooltipContent.displayName = "SectionStatusTooltipContent";

export const SectionStatusTooltipItemOne = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionStatusTooltipItemOne"
        description="Section status tooltip item one."
        defaultMessage="Published - your WebAR Lens URL is publicly available."
    />
);
SectionStatusTooltipItemOne.displayName = "SectionStatusTooltipItemOne";

export const SectionStatusTooltipItemTwo = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionStatusTooltipItemTwo"
        description="Section status tooltip item two."
        defaultMessage="Draft - your WebAR Lens URL is not visible to the public."
    />
);
SectionStatusTooltipItemTwo.displayName = "SectionStatusTooltipItemTwo";

export const SectionLensEnableLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionLensEnableLabel"
        description="Section lens enable label."
        defaultMessage="Enable WebAR Lens URL"
    />
);
SectionLensEnableLabel.displayName = "SectionLensEnableLabel";

export const SectionLensEnableTooltipContent = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.sectionLensEnableTooltipContent"
        description="Section lens enable tooltip content."
        defaultMessage="Enabling this WebAR Lens URL will make your Lens visible to the public."
    />
);
SectionLensEnableTooltipContent.displayName = "SectionLensEnableTooltipContent";

export const AddHostedLensModalLensFolderTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.addHostedLensModalLensFolderTitle"
        description="Add hosted lens modal lens folder title."
        defaultMessage="Select a Lens Folder"
    />
);
AddHostedLensModalLensFolderTitle.displayName = "AddHostedLensModalLensFolderTitle";

export const AddHostedLensModalLensTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.addHostedLensModalLensTitle"
        description="Add hosted lens modal lens title."
        defaultMessage="Select a Lens to generate the WebAR Lens URL"
    />
);
AddHostedLensModalLensTitle.displayName = "AddHostedLensModalLensTitle";

export const HostedLensPageDisabledButton = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensPageDisabledButton"
        description="Hosted lens page disabled button."
        defaultMessage="At least one Lens Folder with a Lens must exist to generate a WebAR Lens URL."
    />
);
HostedLensPageDisabledButton.displayName = "HostedLensPageDisabledButton";

export const HostedLensDeletedTooltipText = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensDeletedTooltipText"
        description="Hosted lens deleted tooltip text."
        defaultMessage="Main Lens was deleted, please delete this Hosted WebAR Lens."
    />
);
HostedLensDeletedTooltipText.displayName = "HostedLensDeletedTooltipText";

export const HostedLensDisabledTooltipText = (): ReactElement => (
    <FormattedMessage
        id="apps.hostedLenses.components.hostedLensDisabledTooltipText"
        description="Hosted lens disabled tooltip text."
        defaultMessage="Hosted WebAR Lens URLs' can only be generated for a Lens that has been processed and is approved."
    />
);
HostedLensDisabledTooltipText.displayName = "HostedLensDisabledTooltipText";
